var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconApplySingleModified = function SvgIconApplySingleModified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 7.571c0-.416.164-.816.456-1.11.291-.295.687-.461 1.1-.461h10.888c.413 0 .809.166 1.1.46S18 7.155 18 7.571v7.858c0 .416-.164.816-.456 1.11-.291.295-.687.461-1.1.461H5.556c-.413 0-.809-.166-1.1-.46A1.58 1.58 0 0 1 4 15.429z"
  })));
};
export default SvgIconApplySingleModified;